module.exports = "/davinci/assets/9c2aeeb16c35900ee29f5c4789cae9cc.jpg";